<template>

<div id="app">
    <div class="container">
      <div class="logo">
        <router-link :to="{ path: '/zmist' }"><img src="@/assets/logo.png" class="book-logo"></router-link>
        <router-link :to="{ path: '/zmist' }"><img src="@/assets/ababa-logo.png" class="ababa-logo"></router-link>
        <div class="header">
          <transition name="component-fade" mode="out-in">
            <component v-bind:is="block1"></component>
          </transition>
        </div>
      </div>

      <router-view ></router-view> 

      <div class="footer">
        Усі права застережено<br /><a target="_blank" href="http://ababahalamaha.com.ua">«А-БА-БА-ГА-ЛА-МА-ГА»</a>, 2020
      </div>  
    </div>
</div>
</template>


<script>
//import AppHeader from './Header'
//import Footerr from './Footer'



export default {

   data() {
    return {
      logo: 'https://antkiv.ababahalamaha.com/images/name_logo2.png',
    block1: 'hd', 
  
    }    
  },
  components: {
    'text_logo': {
      template: '<img src="/images/header.png">'
    },
    'hd': {
      template: ' '
    },
    
  },


  created: function() {
    setTimeout(() => this.Animation(1), 3000);

   }, 

   methods: {

    Animation(status) {

      if (status) {
        this.block1 = 'text_logo';
        setTimeout(() => this.Animation(0), 7000);
        //console.log('1')
      } else {
        this.block1 = 'hd';
        setTimeout(() => this.Animation(1), 6000);
        //console.log('0')
      }

    }

  }
  
  }

</script>